import {
  headTitleList1,
  headTitleList2,
  headTitleList3,
  stepperData,
} from "./parts";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkStrpper from "../../components/atoms/TkStepper";
import { Box, Typography } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import TkTable from "../../components/atoms/TkTable";
import { httpAPI_APP003, httpAPI_COM005, httpAPI_COM009 } from "./api/request";
import { IAPI_APP003_Request } from "../../type/apiType";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkButton from "../../components/atoms/TkButton";
import { changeZipcodeFormat } from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  formClassFacility,
  FormKbn,
  Prefectures,
  Status,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { ApplyFacilityInfoList } from "../../type/apiType/IAPI_APP003";

/**
 * SCRC070104 申請情報詳細（新設届）
 * @returns JSX.Element
 */
const SCRC070104 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  // 基本情報
  const [bodyList1, setBodyList1] = useState([]);

  // 「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報
  const [bodyList2, setBodyList2] = useState([]);

  // 職員数情報
  const [bodyList3, setBodyList3] = useState([]);

  const [activeStepData, setActiveStepData] = useState(0);
  const timerId = useRef<NodeJS.Timeout | null>(null);
  const [file, setFile] = useState<{
    filebase64: string;
    filedisable: boolean;
  }>({
    filebase64: "",
    filedisable: true,
  });
  const [specialfile, setSpecialfile] = useState<{
    specialfilebase64: string;
    specialfiledisable: boolean;
  }>({
    specialfilebase64: "",
    specialfiledisable: true,
  });
  const isFileReady = useRef<{ file: boolean; specialfile: boolean }>({
    file: false,
    specialfile: false,
  });
  const isSpecificNursingCareFacility = useRef<boolean>(false);
  const isProposalFacility = useRef<boolean>(false);

  const applyId =
    location.state?.applyId ??
    businessState?.job_15?.applyId ??
    businessState?.job_23?.applyId;

  // 職員情報参照ボタン押す
  const handleClick = (item: any) => {
    setBusinessState({
      job_23: {
        applyId,
        registrationProcedureInfo: {
          facilityNo: item.facilityNo,
          facilityName: item.facilityName,
          facilityKind: item.facilityKind,
        },
      },
    });
    navigate("/SCRC070003");
  };

  const handleInit = async () => {
    const applyIdData: IAPI_APP003_Request = {
      applyId: applyId,
    };
    try {
      const res = await httpAPI_APP003({
        ...applyIdData,
      });

      if (res.resultCd === "I0000") {
        const completeMap = [
          Status["通知待ち"],
          Status["通知拒絶待ち"],
          Status["郵送待ち"],
          Status["郵送拒絶待ち"],
          Status["処理完了"],
          Status["処理拒絶完了"],
          Status["取下済"],
        ];
        if (completeMap.includes(res.latestApplyStatus as Status)) {
          setActiveStepData(2);
        } else {
          setActiveStepData(1);
        }

        isSpecificNursingCareFacility.current = Object.values(
          res?.applyFacilityInfoList!
        ).some(
          (applyFacilityInfo) =>
            applyFacilityInfo.facilityKbn === "特定介護保険施設等"
        );

        isProposalFacility.current = Object.values(
          res?.applyFacilityInfoList!
        ).some(
          (applyFacilityInfo) => applyFacilityInfo.facilityKbn === "申出施設等"
        );

        // 基本情報データの設置
        let data1: any = [];
        res?.applyFacilityInfoList?.forEach((item) => {
          let documentaryEvidence = res.fileList?.find(
            (file) =>
              file.formKbn === FormKbn["施設書類"] &&
              file.formClass ===
                formClassFacility["当該施設・事業を経営している証拠書類"] &&
              file.facilityNo === item.facilityNo
          );
          const itemData = [
            {
              children: item.applyDate,
            },
            {
              children: (
                <Box>
                  <Typography>
                    {(item.facilityNo ?? "") + ":" + (item.facilityName ?? "")}
                  </Typography>
                  <Typography>{changeZipcodeFormat(item.zipcode)}</Typography>
                  <Typography>
                    {"" +
                      (item.prefecture
                        ? TkGetCode(Prefectures, item.prefecture)
                        : "") +
                      (item.addressCity ?? "") +
                      (item.addressOthers ?? "")}
                  </Typography>
                </Box>
              ),
            },
            {
              children: item.facilityKind,
            },
            {
              children: item.facilityKbn,
            },
            {
              children: documentaryEvidence ? (
                <TkDownloadLink
                  dataname={documentaryEvidence.fileName ?? ""}
                  base64filedata={documentaryEvidence.fileBase64 ?? ""}
                  downloadBase64
                />
              ) : null,
            },
          ];
          data1.push(itemData);
        });
        setBodyList1(data1);
        // 「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報データの設置
        let data2: any = [];
        res?.applyFacilityAddInfoList?.forEach((item) => {
          const itemData = [
            {
              children:
                (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            },
            {
              children: TkGetCode(YesOrNoFlug, item.salaryPaymentDelayFlg),
            },
            {
              children: TkGetCode(YesOrNoFlug, item.hadContractFlg),
            },
            {
              children: item.pastContractCancelDate,
            },
          ];
          data2.push(itemData);
        });

        setBodyList2(data2);

        // 職員数情報
        let data3: any = [];
        res.staffNumInfoList?.forEach((item) => {
          const itemData = [
            {
              children: item.facilityKind,
            },
            {
              children:
                (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            },
            {
              children: item.admissionCapacityNum,
            },
            {
              children: item.staffBaseNum,
            },
            {
              children: (
                <Box className="infoBtn">
                  <TkButton
                    onClick={() => {
                      handleClick(item);
                    }}
                    data-testid="SCRC070104Worker"
                  >
                    職員情報参照
                  </TkButton>
                </Box>
              ),
            },
          ];
          data3.push(itemData);
        });
        setBodyList3(data3);
        handleDownloadData(res.applyFacilityInfoList || []);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDownloadData = async (
    applyFacilityInfoList: ApplyFacilityInfoList[]
  ) => {
    try {
      // 特定介護保険施設等のfacilityKbnが含まれるか
      const careFlag =
        applyFacilityInfoList?.filter?.(
          (item) => item.facilityKbn === "特定介護保険施設等"
        )?.length > 0;
      // 申出施設等のfacilityKbnが含まれるか
      const offerFlag =
        applyFacilityInfoList?.filter?.(
          (item) => item.facilityKbn === "申出施設等"
        )?.length > 0;
      const FormList = [];
      if (careFlag) FormList.push({ formClass: "RPT0203025", formKbn: "1" });
      if (offerFlag) FormList.push({ formClass: "RPT0203026", formKbn: "1" });
      if (!FormList?.length) return;
      // 帳票作成状況取得APIを呼び出す。
      const res = await httpAPI_COM009({
        applyId,
        FormList,
      });

      if (res.resultCd === "I0000") {
        let requestId: any = [];
        res.FormList?.forEach((item) => {
          if (item.formOutputStatus === "3") {
            if (item.formClass === "RPT0203025" && !isFileReady.current.file) {
              requestId = item.requestId;
              handleFileDownload(requestId, "RPT0203025");
              isFileReady.current.file = true;
            } else if (
              item.formClass === "RPT0203026" &&
              !isFileReady.current.specialfile
            ) {
              requestId = item.requestId;
              handleFileDownload(requestId, "RPT0203026");
              isFileReady.current.specialfile = true;
            }
          }
        });

        if (careFlag && !offerFlag && isFileReady.current.file) return;
        if (!careFlag && offerFlag && isFileReady.current.specialfile) return;
        if (
          careFlag &&
          offerFlag &&
          isFileReady.current.file &&
          isFileReady.current.specialfile
        )
          return;

        timerId.current = setTimeout(() => {
          handleDownloadData(applyFacilityInfoList);
        }, 10000);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleFileDownload = async (requestId: string, formClass: string) => {
    // 帳票ダウンロード(汎用)APIを呼び出す
    try {
      const res = await httpAPI_COM005({
        formList: [{ requestId: requestId }],
      });

      if (res.resultCd === "I0000") {
        if (formClass === "RPT0203025") {
          setSpecialfile({
            ...specialfile,
            specialfilebase64: res.formList?.[0].fileBase64 || "",
            specialfiledisable: false,
          });
        } else if (formClass === "RPT0203026") {
          setFile({
            ...file,
            filebase64: res.formList?.[0].fileBase64 || "",
            filedisable: false,
          });
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC070104" data-testid="SCRC070104PageForTest">
      <TkStrpper steps={stepperData} activeStep={activeStepData}></TkStrpper>

      <Box>
        <Box className="info">基本情報</Box>
        <TkTable bodyList={bodyList1} headList={headTitleList1} />

        <Box className="info">
          「特定介護保険施設等」又は「申出施設等」に該当する申込施設の付加情報
        </Box>
        <TkTable bodyList={bodyList2} headList={headTitleList2} />

        <Box className="info">職員数情報</Box>
        <TkTable bodyList={bodyList3} headList={headTitleList3} />

        {(isSpecificNursingCareFacility.current ||
          isProposalFacility.current) && (
          <Box className="info">
            関連帳票
            <Box className="space">
              {isProposalFacility.current && (
                <TkDownloadLink
                  base64filedata={file.filebase64}
                  dataname="申出施設等承諾書"
                  isButton
                  linkDisabled={file.filedisable}
                  buttonDisabled={file.filedisable}
                  downloadBase64={true}
                />
              )}
              {isSpecificNursingCareFacility.current && (
                <TkDownloadLink
                  base64filedata={specialfile.specialfilebase64}
                  dataname="特定介護保険施設等承諾書"
                  isButton
                  linkDisabled={specialfile.specialfiledisable}
                  buttonDisabled={specialfile.specialfiledisable}
                  downloadBase64={true}
                />
              )}
            </Box>
          </Box>
        )}
      </Box>
      <Box className="backbtn">
        <TkBackButton></TkBackButton>
      </Box>
    </Box>
  );
};

export default SCRC070104;
